// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/billing/billing.actions.go

export const LIST_SUBSCRIPTIONS =
  "mondoo.billing.BillingManager.ListSubscriptions";
